import { Splide } from "@splidejs/splide";


const carousel = () => {
  const targetElms = document.getElementsByClassName('js-sliderNews');
  if(targetElms.length === 0) return;
  for(const targetElm of targetElms) {
    const speed = 800;
    const isLoop = targetElm.classList.contains('--loop');
    console.log(isLoop);
    // スライドの数を取得
    const slideCount = targetElm.querySelectorAll('.splide__slide').length;
    
    let options = {
      type: isLoop ? 'loop' : 'slide',
      // loopじゃなければ､ドラッグ不可にする
      drag: isLoop,
      speed: speed,
      rewindSpeed: speed,
      autoWidth: true,
      gap: "6rem",
      arrows: false,
      pagination: true,
      autoplay: slideCount > 3, // 3枚以下ならfalse
      pauseOnHover: true,
      breakpoints: {
          768: {
              type: 'loop',
              drag: true,
              gap: "3rem",
              autoplay: true, // 3枚以下ならfalse
          },
        },
      reduceMotion: {
        speed: speed,
        rewindSpeed: speed,
        autoplay: slideCount > 3, // 3枚以下ならfalse
      }
    }
    if(targetElm.dataset.speed) {
      options.speed = parseInt(targetElm.dataset.speed);
      options.rewindSpeed = parseInt(targetElm.dataset.speed);
      options.reduceMotion.speed = parseInt(targetElm.dataset.speed);
      options.reduceMotion.rewindSpeed = parseInt(targetElm.dataset.speed);
    }

    if(targetElm.dataset.gap) {
      options.gap = targetElm.dataset.gap;
    }

    const slider = new Splide(targetElm, options);
    slider.mount();
  }
}

const init = () => {
  carousel();
}
export default init;